import { useFormikContext } from "formik";
import PropTypes from "prop-types";
import ErrorMessage from "../Errors/ErrorMessage";

const Textarea = ({ title, name, className, serverError }) => {
  const { errors, handleChange, values } = useFormikContext();
  return (
    <div className='form-group'>
      <label className='f-13 text-dark text-left d-flex flex-row justify-content-start'>
        {title}
      </label>
      <textarea
        name={name}
        type='text'
        className={`form-control ${className} f-13`}
        value={values[name]}
        onChange={handleChange}
      ></textarea>
      <ErrorMessage error={errors[name] ? errors[name] : serverError} />
    </div>
  );
};

Textarea.propTypes = {
  title: PropTypes.string,
  name: PropTypes.string.isRequired,
  className: PropTypes.string,
  serverError: PropTypes.any,
};

export default Textarea;
